module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row contact-item list-item",
    class: {
      clickable: !_vm.is_processing
    },
    on: {
      "click": function($event) {
        return _vm.rowClicked($event)
      }
    }
  }, [_c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item clickable-element",
    on: {
      "click": _vm.toggleSelected
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selected || _vm.all_group_contacts_selected
    }
  }), _c('label', [_vm._v(" ")])])]), _c('div', {
    staticClass: "table-col contact-list-item-name overflow-hidden",
    class: _vm.view_mode.import_action ? 'table-col-200' : 'table-col-120'
  }, [_c('div', {
    staticClass: "contact-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.contact_group.name))])]), (_vm.contact_group.hasStatusMessage()) ? _c('div', {
    staticClass: "table-col table-col-300 message-status-table-col"
  }, [_c('div', {
    class: _vm.contact_group_status_message_class
  }, [_vm._v(_vm._s(_vm.contact_group_status_message))])]) : [(_vm.view_mode.statistics) ? _c('div', {
    staticClass: "table-col"
  }, [_c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.opportunities))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.connections')))])])]) : _vm._e(), (_vm.view_mode.import_action) ? _c('div', {
    staticClass: "table-col"
  }, [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v(_vm._s(_vm.import_action_label))])]) : _vm._e(), (_vm.view_mode.contacts_count) ? _c('div', {
    staticClass: "table-col"
  }, [_c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.contact_group.contacts_count))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.contacts')))])])]) : _vm._e()], (_vm.view_mode.user) ? _c('div', {
    staticClass: "table-col contact-list-item-user"
  }, [_c('user-miniature', {
    attrs: {
      "user": _vm.contact_group.user,
      "options": {
        first_name: true
      }
    }
  })], 1) : _vm._e(), (_vm.view_mode.actions_dropdown) ? _c('div', {
    staticClass: "table-col table-col-collapsed",
    on: {
      "!click": function($event) {}
    }
  }, [_c('div', {
    staticClass: "action clickable-element"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu multi-level"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.editGroup
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))])]), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.destroyGroup($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])])])])])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50e09d38!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contact_groups/list_item.vue
// module id = 1111
// module chunks = 1